<template>
  <div class="main-box main-min-height bgffffff">
    <div class="table-box">
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row :gutter="22">
            <el-col :span="4">
              <el-form-item label-width="0px">
                <el-button type="primary" @click="Edit(false)">
                  添加
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="id" align="center" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="commodityType" align="center" label="分类名称">
        </el-table-column>
        <el-table-column label="操作" align="center" width="160">
          <template slot-scope="{row}">
            <el-button size="mini" @click="Edit(true,row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="del(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Dialogs v-model="dialogEditVisible" :center='true' :title='title' :HeaderPosition='true' width-dial="400px" :height-dial="50" @dialog="submit">
      <el-form size='mini' :model="ruleForm" :rules="rules" ref="ruleForm" label-position='right' label-width="110px">
        <el-form-item prop="commodityType" label="商品分类名称">
          <el-input v-model="ruleForm.commodityType" style="width:100%" placeholder="-请输入-" />
        </el-form-item>
      </el-form>
    </Dialogs>
  </div>
</template>

<script>
import Dialogs from '@/components/DiaLogs'
export default {
  name: 'Classification',
  components: { Dialogs },
  data() {
    return {
      searchForm: {
        date: null,
        beginTime: null, //下单开始时间
        endTime: null, //下单结束时间
      },//查询条件
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      tableData: [],//表格参数
      BusinessList: [],//商户列表
      dialogEditVisible: false,
      ruleForm: {
        commodityType: null,
        id: null,
      },
      rules: {
        commodityType: [
            { required: true, message: '请输入名称', trigger: 'blur' }
        ],
      },
      title: '新增商品分类',
    };
  },
  computed: {},
  watch: {
    'searchForm.date': {
      handler(val) {
        this.searchForm.beginTime = val[0]
        this.searchForm.endTime = val[1]
      },
      deep: true
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    //获取查询信息
    getInfo() {
      this.$Classification.list(
        {
          ...this.searchForm,
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.result
        }
      })
    },
    //删除
    del(id) {
      this.$Classification.del({ ids: id }).then(({ data }) => {
        if (data.code === 200) {
          this.messages(data.message, true, 1000)
          this.getInfo()
        }
      })
    },
    Edit(bool,data) {
        Object.keys(this.ruleForm).forEach(item => this.ruleForm[item] = null)
        if(bool){
          Object.keys(this.ruleForm).forEach(item => this.ruleForm[item] = data[item])
        }
        this.dialogEditVisible = true
    },
    //提交
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
        console.log('保存')
          this.$Classification.save({ ...this.ruleForm }).then(({ data }) => {
            if (data.code === 200) {
              this.messages(data.message, true, 1000, () => {
                this.getInfo();
                this.dialogEditVisible = false
              })
            }
          })
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.y_color {
  color: #ff702e;
}
.lv_color {
  color: #0acd5e;
}
</style>
